//path: src\modules\utils\stringUtils.ts

import { v4 as uuidv4 } from 'uuid';

export function IsNullOrEmpty(input: string | null | undefined) {
  return (
    input === undefined ||
    input === null ||
    (typeof input === 'string' && input.trim() === '')
  );
}

export function Uid() {
  return uuidv4();
}

export { cn } from './cn';
